/**
 * Thin wrapper around the Meta Pixel global. The pixel is loaded lazily by the
 * consent layer (see src/consent/), so guard every call — `fbq` is undefined
 * until marketing consent is granted, and never exists in tests/SSR. The
 * `window.fbq` type is declared in src/consent/consentTags.ts.
 */

/** Fire when a visitor completes a real conversion (e.g. the early-access form). */
export function trackLead(): void {
  window.fbq?.('track', 'Lead');
}
